export default __webpack_public_path__ + "static/media/dataValue.bbee25e6.jpg";